module.exports = __webpack_public_path__ + "static/media/AF.1681e9c4.png";